import { TableIdType } from '@/scripts/dataBase/type';
import DatabaseWorkerManager from '@/scripts/dataBase/databaseWorkerManager';

export type { WorkerMessage } from '@/scripts/dataBase/type';

const dbWorkerManager = new DatabaseWorkerManager();

export const sendSessionDB = dbWorkerManager.getSendWorker(TableIdType.sessionTable);
export const sendMessageDB = dbWorkerManager.getSendWorker(TableIdType.messageTable);
export const sendUserDB = dbWorkerManager.getSendWorker(TableIdType.userTable);
export const sendContactDB = dbWorkerManager.getSendWorker(TableIdType.contactsTable);
export const sendGroupDB = dbWorkerManager.getSendWorker(TableIdType.groupTable);
export const sendGroupSetDB = dbWorkerManager.getSendWorker(TableIdType.groupSetTable);
export const sendGroupMemberDB = dbWorkerManager.getSendWorker(
  TableIdType.groupMemberTable
);
export const sendReadStateDB = dbWorkerManager.getSendWorker(
  TableIdType.readStateTable
);
// export const sendEncryptionDB = dbWorkerManager.getSendWorker(
//   TableIdType.encryptionTable
// );
export default dbWorkerManager;
